import React from "react";
import { Helmet } from "react-helmet-async";
import "./Intro.css";
import heroImg from "../../../Assets/HomePage_Assets/valscoLogo.gif";

function Intro() {
  return (
    <>
      <Helmet>
        <title>Valsco Technology – Digital Experiences</title>
        <meta
          name="description"
          content="Valsco Technology builds high-performance software products and enterprise-grade digital solutions."
        />
      </Helmet>

      <section className="landing_wrapper" id="landing">
        {/* LEFT : LOGO */}
        <div className="landing_img">
          <img src={heroImg} alt="Valsco Technology" />
        </div>

        {/* RIGHT : CONTENT */}
        <div className="landing_desc">
          <h1 className="hero_title">
            Crafting 
            <br />
            digital experiences
          </h1>

          <p className="hero_description">
            Valsco Technology provides software products and services to businesses individuals to help them meet their software needs. We strive to specialize in developing software solutions tailored to the unique needs of our clients.
          </p>

          {/* TRUST ROW */}
          <div className="hero_trust">
            <span>✔ Enterprise Solutions</span>
            <span>✔ Scalable Architecture</span>
            <span>✔ Modern Tech Stack</span>
          </div>
        </div>
      </section>
    </>
  );
}

export default Intro;
